import { find, get } from "lodash";
function getMilitaryEnumDisplayName(value, enums, key) {
  return get(find(get(enums, "contact_data.military.".concat(key)), {
    value: value
  }), 'display_name');
}
export default getMilitaryEnumDisplayName;
//# sourceMappingURL=getMilitaryEnumDisplayName.js.map